import { EditBtn } from '../../StandardizationProject/styles';
import { ProjectIdCardLink, CreateIdCardLink } from './styles';
import styled from 'styled-components';
import moment from 'moment';

export const columns = [
  {
    Header: 'Edit',
    accessor: 'id',
    Cell: ({ row, onEditProject }) => {
      if (row.original.canEdit) return (
        <EditBtn
          onClick={() => onEditProject(row.original)}
          wrapperStyle={{
            width: '100%',
          }}
        />
      );
      else return null},
  },
  {
    Header: 'Project Number',
    accessor: 'number',
    Cell: ({ value }) => value && `${value}`,
  },
  {
    Header: 'Project Name/Description',
    accessor: 'name',
  },
  {
    Header: 'Location',
    accessor: 'location',
  },
  {
    Header: 'Client',
    accessor: 'client',
  },
  {
    Header: 'Oil Flowrate (bbld)',
    accessor: 'oilFlowRate',
  },
  {
    Header: 'Gas Rate (MM scfd)',
    accessor: 'gasRate',
  },
  {
    Header: 'Water Injection (m3/d)',
    accessor: 'waterInjection',
  },
  {
    Header: 'Gas Injection (y/n)',
    accessor: 'gasInjection',
    Cell: ({ value }) => (value ? 'y' : 'n'),
  },
  {
    Header: 'Gas Export (y/n) ',
    accessor: 'gasExport',
    Cell: ({ value }) => (value ? 'y' : 'n'),
  },
  {
    Header: 'Start date',
    accessor: 'date',
    Cell: ({ value }) => value && <DateFieldWrapper>{moment(value).format('DD-MM-YYYY')}</DateFieldWrapper>,
  },
  {
    Header: 'ID Card',
    accessor: 'projectIdCardExists',
    Cell: ({ row, onOpenProjectIdCard, onCreateProjectIdCard, isCatalogAdmin }) => {
      return row.original.projectIdCardExists ?
          <ProjectIdCardLink onClick={() => onOpenProjectIdCard(row.original.id)}>Open</ProjectIdCardLink>
          : isCatalogAdmin && <CreateIdCardLink onClick={() => onCreateProjectIdCard(row.original.id)}>Create</CreateIdCardLink>;
    },
  },
  {
    id: 'expander',
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
        <span {...getToggleAllRowsExpandedProps()}>

          </span>
    ),
    Cell: ({ row }) =>
        // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
        // to build the toggle for expanding a row
        <span
            {...row.getToggleRowExpandedProps({
              style: {
                // We can even use the row.depth property
                // and paddingLeft to indicate the depth
                // of the row
                paddingLeft: `${row.depth * 2}rem`,
              },
            })}
        >
          {row.canExpand ? row.isExpanded ? 'V' : '>' : ''}
        </span>
  },
];

const DateFieldWrapper = styled.div`
  min-width: 90px;
  font-size: 0.8rem;
`;
